import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class EmailIntegrationService {
  constructor(private http: HttpClient) {}

  readEmails(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/emails/read`);
  }
}
